import { container } from 'inversify-props';
import { IAppConfig, IAppConfigId } from '@/features/shared/IAppConfig';
import AppConfig from '@/features/shared/AppConfig';
import { IStatisticsApi, IStatisticsApiId } from '@/features/statistics/IStatisticsApi';
import StatisticsApi from '@/features/statistics/StatisticsApi';
import localForage, { LocalForageId } from './localforage';
import axios, { AxiosId } from './axios';
import { AxiosInstance } from 'axios';
import { ISettingsService, ISettingsServiceId } from '@/features/shared/ISettingsService';
import SettingsService from '@/features/shared/SettingsService';
import { IStatisticsService, IStatisticsServiceId } from '@/features/statistics/IStatisticsService';
import MpcStatisticsService from '@/features/statistics/StatisticsService';
import { ITripService, ITripServiceId } from '@/features/trips/ITripService';
import TripService from '@/features/trips/TripService';
import { IDriverMessagesApi, IDriverMessagesApiId } from '@/features/messages/IDriverMessagesApi';
import DriverMessagesApi from '@/features/messages/DriverMessagesApi';
import { IDriverMessagesService, IDriverMessagesServiceId } from '@/features/messages/IDriverMessagesService';
import DriverMessagesService from '@/features/messages/DriverMessagesService';
import { ISettingsApi, ISettingsApiId } from '@/features/shared/ISettingsApi';
import { SettingsApi } from '@/features/shared/SettingsApi';
import { ITripsApi, ITripsApiId } from '@/features/trips/ITripsApi';
import TripsApi from '@/features/trips/TripsApi';
import { ILineService, ILineServiceId } from '@/features/lines/ILineService';
import { ILinesApi, ILinesApiId } from '@/features/lines/ILinesApi';
import LineService from '@/features/lines/LineService';
import LinesApi from '@/features/lines/LinesApi';

export default function containerBuilder(options?: any) {
    container.bind<IAppConfig>(IAppConfigId).toConstantValue({ ...AppConfig, ...options });
    container.bind<AxiosInstance>(AxiosId).toConstantValue(axios);
    container.bind<IStatisticsApi>(IStatisticsApiId).to(StatisticsApi).inSingletonScope();
    container.bind<ILineService>(ILineServiceId).to(LineService).inSingletonScope();
    container.bind<ILinesApi>(ILinesApiId).to(LinesApi).inSingletonScope();
    container.bind<ITripService>(ITripServiceId).to(TripService).inSingletonScope();
    container.bind<ITripsApi>(ITripsApiId).to(TripsApi).inSingletonScope();
    container.bind<LocalForage>(LocalForageId).toConstantValue(localForage);
    container.bind<ISettingsApi>(ISettingsApiId).to(SettingsApi).inSingletonScope();
    container.bind<ISettingsService>(ISettingsServiceId).to(SettingsService).inSingletonScope();
    container.bind<IStatisticsService>(IStatisticsServiceId).to(MpcStatisticsService).inSingletonScope();
    container.bind<IDriverMessagesApi>(IDriverMessagesApiId).to(DriverMessagesApi).inSingletonScope();
    container.bind<IDriverMessagesService>(IDriverMessagesServiceId).to(DriverMessagesService).inSingletonScope();
}
